<template>
  <v-main class="tpadding">
    <v-container fluid>
      <v-card class="rounded-xl elevation-5">
        <v-toolbar dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title>Reporte Regio Ruta Extendido</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                v-if="canConciliacion"
                small
                text
                :disabled="!isFiltroValido"
                v-bind="attrs"
                v-on="on"
                @click="irConciliacion"
              >
                Conciliación Regio Ruta
                <v-icon right>mdi-clipboard-check-outline</v-icon>
              </v-btn>
            </template>
            <span>Abre la conciliación por ramal y día con los mismos filtros (cliente, ramal y fechas) para descargar CSV o PDF institucional.</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn small text :loading="loadingReports" v-bind="attrs" v-on="on" @click="exportarCSV">
                Descargar resultados
                <v-icon right>mdi-microsoft-excel</v-icon>
              </v-btn>
            </template>
            <span>Exporta el detalle por viaje (CSV) según tu rol: horario plan, cumplimiento GPS y motivo sin cruce (ventana y distancia) si tienes permiso de diagnóstico.</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn small text :loading="loadingExcel" :disabled="!isFiltroValido" v-bind="attrs" v-on="on" @click="ui.modalReporte = true">
                Reporte Regio Ruta Extendido
                <v-icon right>mdi-file-chart-outline</v-icon>
              </v-btn>
            </template>
            <span>Reporte operativo/facturable (Excel o PDF) agregado por periodo: corridas, kilómetros e importe. El Excel incluye hoja Detalle viajes si consultaste y tienes permiso de cumplimiento.</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text>
          <v-row no-gutters class="pb-4" style="justify-content: space-between">
            <v-col sm="10" style="align-self: center; display: flex; flex-direction: column">
              <v-row>
                <v-col cols="2" class="d-flex align-end">
                  <v-autocomplete
                    v-model="selectedClienteId"
                    :items="clientItem"
                    item-text="text"
                    item-value="value"
                    label="Cliente"
                    dense
                    clearable
                    prepend-inner-icon="mdi-account-multiple"
                    :loading="loadingClients"
                    hide-details
                    class="mt-1"
                  />
                </v-col>

                <v-col cols="3" class="d-flex align-end">
                  <v-autocomplete
                    v-model="selectedRamalIds"
                    :items="ramalItems"
                    item-text="text"
                    item-value="value"
                    label="Ramal (opcional)"
                    dense
                    clearable
                    multiple
                    chips
                    small-chips
                    prepend-inner-icon="mdi-sign-direction"
                    :disabled="!Number.isFinite(idclienteEff)"
                    :loading="loadingRamales"
                    hide-details
                    class="mt-1"
                    no-data-text="Selecciona un cliente"
                  />
                </v-col>

                <v-col cols="2" class="d-flex align-end">
                  <v-dialog
                    ref="dialogIni"
                    v-model="ui.modalIni"
                    :return-value.sync="filtros.fecha_inicio"
                    persistent
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        :value="formatFechaDisplay(filtros.fecha_inicio)"
                        dense
                        label="Fecha inicio"
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="ui.tmpIni"
                      scrollable
                      locale="es"
                      :min="fechaMinReporte"
                      :max="fechaMaxReporte"
                    >
                      <v-spacer />
                      <v-btn text @click="ui.modalIni = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="acceptFechaInicio">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="2" class="d-flex align-end">
                  <v-dialog
                    ref="dialogFin"
                    v-model="ui.modalFin"
                    :return-value.sync="filtros.fecha_fin"
                    persistent
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        :value="formatFechaDisplay(filtros.fecha_fin)"
                        dense
                        label="Fecha fin"
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="ui.tmpFin"
                      :min="filtros.fecha_inicio || fechaMinReporte"
                      scrollable
                      locale="es"
                      :max="fechaMaxReporte"
                    >
                      <v-spacer />
                      <v-btn text @click="ui.modalFin = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="acceptFechaFin">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="3" class="pt-0 d-flex align-end">
                  <v-text-field
                    class="pt-0"
                    v-model="search"
                    label="Buscar"
                    single-line
                    hide-details
                    clearable
                    autocomplete="off"
                  />
                </v-col>


              </v-row>
            </v-col>

            <v-col sm="2" class="text-right" style="margin-top: 21px">
              <v-btn
                small
                outlined
                :loading="loading"
                :disabled="!isFiltroValido"
                color="blueKonect"
                class="ma-auto"
                elevation="0"
                @click="fetchResumen"
              >
                Consultar
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table
            :key="tableKey"
            :headers="headers"
            :items="itemsFiltered"
            :loading="loading"
            :items-per-page="10"
            item-key="_uid"
            loading-text="Cargando registros... Por favor espere"
            :footer-props="{
              itemsPerPageText: 'Elementos por página',
              itemsPerPageAllText: 'Todos',
              itemsPerPageOptions: [5, 10, 25, 50, -1]
            }"
          >
            <template #item.fecha_recorrido="{ item }">
              {{ item.fecha_recorrido_fmt }}
            </template>

            <template #item.tipo_recorrido_label="{ item }">
              <v-tooltip v-if="hasTipoTooltip(item)" bottom max-width="320">
                <template #activator="{ on, attrs }">
                  <v-chip
                    v-if="item.discrepancia_tipo_ramal"
                    x-small
                    label
                    color="amber lighten-4"
                    text-color="amber darken-4"
                    class="font-weight-medium"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left x-small>mdi-alert</v-icon>
                    {{ formatTripTypeLabel(item.tipo_recorrido || item.tipo_recorrido_sigue || item.tipo_sigue_crudo) }}
                  </v-chip>
                  <span
                    v-else
                    class="text-caption font-weight-medium"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ formatTripTypeLabel(item.tipo_recorrido || item.tipo_recorrido_sigue || item.tipo_sigue_crudo) }}
                  </span>
                </template>
                <div>
                  <div v-if="item.discrepancia_tipo_ramal" class="font-weight-medium mb-1">
                    Tipo SIGUE distinto a config ramal
                  </div>
                  <div v-if="item.tipo_sigue_crudo">SIGUE: {{ item.tipo_sigue_crudo }}</div>
                  <div v-if="item.origen_sigue || item.destino_sigue">
                    {{ item.origen_sigue || '-' }} → {{ item.destino_sigue || '-' }}
                  </div>
                  <div v-if="item.fuente_tipo">Fuente: {{ formatFuenteTipo(item.fuente_tipo) }}</div>
                  <div v-if="item.match_origen || item.match_destino">
                    Match: {{ formatMatchLabel(item.match_origen) }} / {{ formatMatchLabel(item.match_destino) }}
                  </div>
                </div>
              </v-tooltip>
              <template v-else>
                <v-chip
                  v-if="item.discrepancia_tipo_ramal"
                  x-small
                  label
                  color="amber lighten-4"
                  text-color="amber darken-4"
                  class="font-weight-medium"
                >
                  <v-icon left x-small>mdi-alert</v-icon>
                  {{ formatTripTypeLabel(item.tipo_recorrido || item.tipo_recorrido_sigue || item.tipo_sigue_crudo) }}
                </v-chip>
                <span v-else class="text-caption font-weight-medium">
                  {{ formatTripTypeLabel(item.tipo_recorrido || item.tipo_recorrido_sigue || item.tipo_sigue_crudo) }}
                </span>
              </template>
            </template>

            <template #item.origen_destino_sigue="{ item }">
              <span v-if="item.origen_sigue || item.destino_sigue" class="text-caption">
                {{ item.origen_sigue || '-' }} → {{ item.destino_sigue || '-' }}
              </span>
              <span v-else class="grey--text">-</span>
            </template>

            <template #item.real_salida_ida="{ item }">
              <span v-if="item.real_salida_ida">{{ item.real_salida_ida }}</span>
              <v-tooltip
                v-else-if="canVerDiagnosticoGps && item.diagnostico_gps?.salida"
                bottom
                max-width="320"
              >
                <template #activator="{ on, attrs }">
                  <v-chip
                    x-small
                    label
                    color="amber lighten-4"
                    text-color="amber darken-4"
                    class="font-weight-medium"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Sin cruce
                    <v-icon right x-small>mdi-information-outline</v-icon>
                  </v-chip>
                </template>
                <span>{{ formatGpsDiagTooltip(item.diagnostico_gps.salida, 'salida') }}</span>
              </v-tooltip>
              <span v-else class="grey--text">-</span>
            </template>

            <template #item.real_llegada_ida="{ item }">
              <span v-if="item.real_llegada_ida">{{ item.real_llegada_ida }}</span>
              <v-tooltip
                v-else-if="!item.real_llegada_retorno && canVerDiagnosticoGps && item.diagnostico_gps?.llegada"
                bottom
                max-width="320"
              >
                <template #activator="{ on, attrs }">
                  <v-chip
                    x-small
                    label
                    color="amber lighten-4"
                    text-color="amber darken-4"
                    class="font-weight-medium"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Sin cruce
                    <v-icon right x-small>mdi-information-outline</v-icon>
                  </v-chip>
                </template>
                <span>{{ formatGpsDiagTooltip(item.diagnostico_gps.llegada, 'llegada') }}</span>
              </v-tooltip>
              <span v-else class="grey--text">-</span>
            </template>

            <template #item.real_salida_retorno="{ item }">
              <span v-if="item.real_salida_retorno">{{ item.real_salida_retorno }}</span>
              <span v-else class="grey--text">-</span>
            </template>

            <template #item.real_llegada_retorno="{ item }">
              <span v-if="item.real_llegada_retorno">{{ item.real_llegada_retorno }}</span>
              <v-tooltip
                v-else-if="canVerDiagnosticoGps && item.diagnostico_gps?.llegada"
                bottom
                max-width="320"
              >
                <template #activator="{ on, attrs }">
                  <v-chip
                    x-small
                    label
                    color="amber lighten-4"
                    text-color="amber darken-4"
                    class="font-weight-medium"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Sin cruce
                    <v-icon right x-small>mdi-information-outline</v-icon>
                  </v-chip>
                </template>
                <span>{{ formatGpsDiagTooltip(item.diagnostico_gps.llegada, 'llegada') }}</span>
              </v-tooltip>
              <span v-else class="grey--text">-</span>
            </template>

            <template #item.cruce_salida_ida_ok="{ item }">
              <v-chip v-if="item.cruce_salida_ida_ok != null" x-small :color="item.cruce_salida_ida_ok ? 'green' : 'grey lighten-2'" :text-color="item.cruce_salida_ida_ok ? 'white' : 'grey darken-2'">{{ item.cruce_salida_ida_ok ? 'Sí' : 'No' }}</v-chip>
              <span v-else class="grey--text">-</span>
            </template>
            <template #item.cruce_llegada_ida_ok="{ item }">
              <v-chip v-if="item.cruce_llegada_ida_ok != null" x-small :color="item.cruce_llegada_ida_ok ? 'green' : 'grey lighten-2'" :text-color="item.cruce_llegada_ida_ok ? 'white' : 'grey darken-2'">{{ item.cruce_llegada_ida_ok ? 'Sí' : 'No' }}</v-chip>
              <span v-else class="grey--text">-</span>
            </template>
            <template #item.cruce_salida_retorno_ok="{ item }">
              <v-chip v-if="item.cruce_salida_retorno_ok != null" x-small :color="item.cruce_salida_retorno_ok ? 'green' : 'grey lighten-2'" :text-color="item.cruce_salida_retorno_ok ? 'white' : 'grey darken-2'">{{ item.cruce_salida_retorno_ok ? 'Sí' : 'No' }}</v-chip>
              <span v-else class="grey--text">-</span>
            </template>
            <template #item.cruce_llegada_retorno_ok="{ item }">
              <v-chip v-if="item.cruce_llegada_retorno_ok != null" x-small :color="item.cruce_llegada_retorno_ok ? 'green' : 'grey lighten-2'" :text-color="item.cruce_llegada_retorno_ok ? 'white' : 'grey darken-2'">{{ item.cruce_llegada_retorno_ok ? 'Sí' : 'No' }}</v-chip>
              <span v-else class="grey--text">-</span>
            </template>

            <template #item.comentarios="{ item }">
              <v-menu
                v-if="item.comentarios && item.comentarios.length"
                offset-y
                max-width="360"
              >
                <template #activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    color="pinkKonect"
                    v-bind="attrs"
                    v-on="on"
                    aria-label="Ver comentarios"
                  >
                    <v-badge
                      :content="item.comentarios.length"
                      color="pinkKonect"
                      overlap
                    >
                      <v-icon>mdi-comment-text-outline</v-icon>
                    </v-badge>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="subtitle-2 py-2 px-3">
                    Comentarios ({{ item.comentarios.length }})
                  </v-card-title>
                  <v-divider />
                  <v-list dense class="py-0">
                    <v-list-item
                      v-for="(c, idx) in item.comentarios"
                      :key="`cmt-${item._uid}-${idx}`"
                      two-line
                    >
                      <v-list-item-content>
                        <v-list-item-title class="text-body-2">
                          {{ c.comentario }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-caption">
                          {{ formatComentarioMeta(c) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
              <span v-else class="grey--text text--lighten-1">-</span>
            </template>

            <template #item.actions="{ item }">
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    aria-label="Detalle en mapa"
                    @click="openMapa(item)"
                  >
                    <v-icon>mdi-map-marker</v-icon>
                  </v-btn>
                </template>
                <span>Detalle</span>
              </v-tooltip>
            </template>

            <template #no-data>No hay información disponible</template>
            <template #no-results>No se obtuvieron resultados</template>
          </v-data-table>

          <v-dialog v-model="dialogs.mapa" max-width="1320px" persistent>
            <v-card class="rounded-xl elevation-3">
              <v-toolbar dense dark color="pinkKonect" elevation="2">
                <v-toolbar-title>
                  Detalle: {{ selectedItem?.nombre_ramal || 'Ramal' }}
                  <small v-if="selectedItem" class="ml-2"> ({{ selectedItem?.fecha_recorrido_fmt || '-' }}) </small>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="onCloseMapa" aria-label="Cerrar">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text class="pa-0">
                <div class="map-detail-wrapper d-flex flex-column">
                <div class="d-flex flex-column flex-md-row map-detail-body">
                  <div class="map-detail-map flex-grow-1">
                <gmap-map
                  ref="gmapDetalle"
                  :center="map.center"
                  :zoom="map.zoom"
                  :options="map.options"
                  style="height: 65vh; width: 100%"
                >
                  <gmap-polyline
                    v-if="route.path.length"
                    :path="route.path"
                    :options="{ strokeColor: '#1976D2', strokeWeight: 4, strokeOpacity: 0.9 }"
                  />
                  <gmap-marker
                    v-if="route.start"
                    :position="route.start"
                    :label="{ text: 'I', color: '#fff' }"
                    :icon="{
                      path: google?.maps?.SymbolPath?.CIRCLE,
                      scale: 8,
                      fillColor: '#2E7D32',
                      fillOpacity: 1,
                      strokeColor: '#1B5E20',
                      strokeWeight: 1
                    }"
                  />
                  <gmap-marker
                    v-if="route.end"
                    :position="route.end"
                    :label="{ text: 'F', color: '#fff' }"
                    :icon="{
                      path: google?.maps?.SymbolPath?.CIRCLE,
                      scale: 8,
                      fillColor: '#C62828',
                      fillOpacity: 1,
                      strokeColor: '#8E0000',
                      strokeWeight: 1
                    }"
                  />
                  <gmap-marker
                    v-for="(stop, idx) in route.stops"
                    :key="`stop-${idx}`"
                    :position="{ lat: stop.lat, lng: stop.lng }"
                    :title="stop.title"
                    :icon="{
                      path: google?.maps?.SymbolPath?.CIRCLE,
                      scale: 6,
                      fillColor: stop.cruzado ? '#1565C0' : '#9E9E9E',
                      fillOpacity: 0.9,
                      strokeColor: stop.cruzado ? '#0D47A1' : '#616161',
                      strokeWeight: 1
                    }"
                  />
                </gmap-map>
                  </div>

                  <v-sheet class="pa-4 map-detail-side">
                  <div v-if="route.loading" class="d-flex align-center justify-center py-8">
                    <v-progress-circular indeterminate color="pinkKonect" class="mr-2" />
                    Cargando ruta…
                  </div>
                  <div v-else-if="route.error" class="d-flex align-center error--text py-4">
                    <v-icon color="error" class="mr-2">mdi-alert-circle-outline</v-icon>
                    {{ route.error }}
                  </div>
                  <template v-else>
                    <v-alert
                      v-if="route.warning"
                      dense
                      outlined
                      type="warning"
                      class="mb-3 text-caption"
                    >
                      {{ route.warning }}
                    </v-alert>
                    <v-chip
                      v-if="route.mapMode"
                      small
                      label
                      :color="route.mapMode === 'traffilog_geofence' ? 'teal lighten-5' : 'grey lighten-3'"
                      :text-color="route.mapMode === 'traffilog_geofence' ? 'teal darken-3' : 'grey darken-2'"
                      class="mb-3 font-weight-medium"
                    >
                      <v-icon left x-small>
                        {{ route.mapMode === 'traffilog_geofence' ? 'mdi-crosshairs-gps' : 'mdi-map-marker-path' }}
                      </v-icon>
                      {{ route.mapMode === 'traffilog_geofence' ? 'Ruta real Traffilog' : 'Georuta planificada' }}
                    </v-chip>

                    <div
                      v-if="selectedItem && (selectedItem.tipo_recorrido || selectedItem.tipo_recorrido_sigue || selectedItem.origen_sigue || selectedItem.destino_sigue)"
                      class="mb-3 text-caption"
                    >
                      <div class="d-flex align-center flex-wrap">
                        <v-chip
                          v-if="selectedItem.discrepancia_tipo_ramal"
                          x-small
                          label
                          color="amber lighten-4"
                          text-color="amber darken-4"
                          class="mr-2 mb-1"
                        >
                          <v-icon left x-small>mdi-alert</v-icon>
                          {{ formatTripTypeLabel(selectedItem.tipo_recorrido || selectedItem.tipo_recorrido_sigue || selectedItem.tipo_sigue_crudo) }}
                        </v-chip>
                        <span v-else class="font-weight-medium mr-2 mb-1">
                          Tipo:
                          {{ formatTripTypeLabel(selectedItem.tipo_recorrido || selectedItem.tipo_recorrido_sigue || selectedItem.tipo_sigue_crudo) }}
                        </span>
                        <span
                          v-if="selectedItem.origen_sigue || selectedItem.destino_sigue"
                          class="grey--text text--darken-2 mb-1"
                        >
                          {{ selectedItem.origen_sigue || '-' }} → {{ selectedItem.destino_sigue || '-' }}
                        </span>
                      </div>
                      <div
                        v-if="selectedItem.fuente_tipo || selectedItem.match_origen || selectedItem.match_destino"
                        class="grey--text mt-1"
                      >
                        <span v-if="selectedItem.fuente_tipo">Fuente: {{ formatFuenteTipo(selectedItem.fuente_tipo) }}</span>
                        <span v-if="selectedItem.match_origen || selectedItem.match_destino">
                          <span v-if="selectedItem.fuente_tipo"> · </span>
                          Match: {{ formatMatchLabel(selectedItem.match_origen) }} / {{ formatMatchLabel(selectedItem.match_destino) }}
                        </span>
                      </div>
                    </div>

                    <div class="map-detail-info mb-4">
                      <div class="d-flex align-center py-1">
                        <v-icon x-small class="mr-2 grey--text text--darken-1">mdi-bus</v-icon>
                        <span class="text-caption grey--text">Económico</span>
                        <span class="text-body-2 font-weight-medium ml-auto text-right">{{ selectedItem?.no_economico || '-' }}</span>
                      </div>
                      <v-divider class="my-1" />
                      <div class="d-flex align-center py-1">
                        <v-icon x-small class="mr-2 grey--text text--darken-1">mdi-account</v-icon>
                        <span class="text-caption grey--text">Operador</span>
                        <span class="text-body-2 font-weight-medium ml-auto text-right">{{ selectedItem?.operador || '-' }}</span>
                      </div>
                      <v-divider class="my-1" />
                      <div class="d-flex align-center py-1">
                        <v-icon x-small class="mr-2 grey--text text--darken-1">mdi-ticket-confirmation-outline</v-icon>
                        <span class="text-caption grey--text">Folio</span>
                        <span class="text-body-2 font-weight-medium ml-auto text-right">{{ selectedItem?.folio_boleta || '-' }}</span>
                      </div>
                      <template v-if="canVerCumplimiento">
                        <v-divider class="my-1" />
                        <div class="d-flex align-center py-1">
                          <v-icon x-small class="mr-2 grey--text text--darken-1">mdi-clock-start</v-icon>
                          <span class="text-caption grey--text">Salida real</span>
                          <span class="text-body-2 font-weight-medium ml-auto text-right">{{ mapSalidaReal || '-' }}</span>
                        </div>
                        <v-divider class="my-1" />
                        <div class="d-flex align-center py-1">
                          <v-icon x-small class="mr-2 grey--text text--darken-1">mdi-clock-end</v-icon>
                          <span class="text-caption grey--text">Llegada real</span>
                          <span class="text-body-2 font-weight-medium ml-auto text-right">{{ mapLlegadaReal || '-' }}</span>
                        </div>
                      </template>
                    </div>

                    <section
                      v-if="route.mapMode === 'traffilog_geofence' && (route.gpsSummary || route.gpsSample.length)"
                      class="mb-4"
                      aria-label="Resumen GPS del trayecto"
                    >
                      <div class="d-flex align-center mb-2">
                        <span class="text-subtitle-2">GPS del trayecto</span>
                        <v-chip
                          v-if="route.gpsSummary && route.gpsSummary.puntos_totales"
                          x-small
                          class="ml-2"
                          color="grey lighten-3"
                        >
                          {{ route.gpsSummary.puntos_totales }} puntos
                        </v-chip>
                      </div>
                      <v-row v-if="route.gpsSummary" dense class="mb-2">
                        <v-col cols="6">
                          <v-sheet outlined rounded class="pa-2 text-center">
                            <div class="text-caption grey--text text--darken-2">Km recorridos (GPS)</div>
                            <div class="text-body-2 font-weight-bold">{{ fmtGpsNum(route.gpsSummary.km_recorrido_gps, 2) }} <span class="text-caption font-weight-regular grey--text">km</span></div>
                          </v-sheet>
                        </v-col>
                        <v-col cols="6">
                          <v-sheet outlined rounded class="pa-2 text-center">
                            <div class="text-caption grey--text text--darken-2">Velocidad máxima</div>
                            <div class="text-body-2 font-weight-bold">{{ fmtGpsNum(route.gpsSummary.velocidad_max_kmh) }} <span class="text-caption font-weight-regular grey--text">km/h</span></div>
                          </v-sheet>
                        </v-col>
                        <v-col cols="6">
                          <v-sheet outlined rounded class="pa-2 text-center">
                            <div class="text-caption grey--text text--darken-2">Velocidad promedio</div>
                            <div class="text-body-2 font-weight-bold">{{ fmtGpsNum(route.gpsSummary.velocidad_prom_kmh) }} <span class="text-caption font-weight-regular grey--text">km/h</span></div>
                          </v-sheet>
                        </v-col>
                        <v-col cols="6">
                          <v-sheet outlined rounded class="pa-2 text-center">
                            <div class="text-caption grey--text text--darken-2">Odómetro (inicio a fin)</div>
                            <div class="text-body-2 font-weight-bold gps-odometer-cell">
                              {{ fmtGpsOdometerRange(route.gpsSummary) }}
                            </div>
                          </v-sheet>
                        </v-col>
                      </v-row>
                      <!-- En viewports angostos (<1300px) la tabla vive en el panel lateral. -->
                      <div v-if="route.gpsSample.length && !isWideViewport">
                        <div class="text-caption grey--text text--darken-2 mb-1">
                          Muestra GPS ({{ route.gpsSample.length }} puntos). Selecciona una fila para centrar el mapa.
                        </div>
                        <v-simple-table dense class="gps-sample-table">
                          <template v-slot:default>
                            <caption class="d-sr-only">Puntos GPS del recorrido con hora, velocidad y kilometraje. Activa una fila para centrar el mapa.</caption>
                            <thead>
                              <tr>
                                <th class="text-left" scope="col">Hora</th>
                                <th class="text-left" scope="col">Velocidad</th>
                                <th class="text-left" scope="col">Odómetro (km)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(point, gpsIdx) in route.gpsSample"
                                :key="`gps-${gpsIdx}-${point.at_local}`"
                                class="gps-sample-row"
                                role="button"
                                tabindex="0"
                                :aria-label="gpsRowAriaLabel(point, gpsIdx)"
                                @click="centerMapOnGpsSample(point)"
                                @keydown.enter.prevent="centerMapOnGpsSample(point)"
                                @keydown.space.prevent="centerMapOnGpsSample(point)"
                              >
                                <td class="gps-num">{{ point.at_local || '-' }}</td>
                                <td class="gps-num">{{ fmtGpsNum(point.speed_kmh) }} km/h</td>
                                <td class="gps-num">{{ fmtGpsNum(point.odometer_km, 1) }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                    </section>

                    <div
                      v-if="route.mapMode === 'traffilog_geofence' && route.referencePoints.length"
                    >
                      <div class="d-flex align-center mb-2">
                        <span class="text-subtitle-2">Paso por puntos de referencia</span>
                        <v-chip x-small class="ml-2" color="grey lighten-3">{{ route.referencePoints.length }}</v-chip>
                      </div>
                      <v-list dense class="py-0 ref-points-list">
                        <template v-for="(punto, idx) in route.referencePoints">
                          <v-divider v-if="idx > 0" :key="`div-${punto.idramal_punto_referencia}`" />
                          <v-list-item :key="punto.idramal_punto_referencia" class="px-1">
                            <v-avatar
                              size="28"
                              :color="punto.cruzado ? 'success' : 'grey lighten-2'"
                              class="mr-3 text-caption font-weight-bold"
                              :class="punto.cruzado ? 'white--text' : 'grey--text text--darken-1'"
                            >
                              {{ punto.cruzado && punto.orden_paso ? punto.orden_paso : '-' }}
                            </v-avatar>
                            <v-list-item-content class="py-2">
                              <div class="text-body-2 font-weight-medium">{{ punto.nombre || '-' }}</div>
                              <div class="text-caption grey--text text--darken-1 d-flex flex-wrap align-center ref-point-meta">
                                <span>{{ refPointTypeLabel(punto.tipo_punto) }}</span>
                                <span v-if="punto.cruzado_at_local" class="d-inline-flex align-center">
                                  <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>{{ punto.cruzado_at_local }}
                                </span>
                                <span class="d-inline-flex align-center">
                                  <v-icon x-small class="mr-1">mdi-map-marker-distance</v-icon>{{ formatDistanciaMin(punto.distancia_min_metros) }}
                                </span>
                              </div>
                            </v-list-item-content>
                            <v-list-item-action class="my-0 ml-1">
                              <v-chip
                                x-small
                                :color="punto.cruzado ? 'success' : 'grey lighten-1'"
                                :text-color="punto.cruzado ? 'white' : 'grey darken-3'"
                              >
                                {{ punto.cruzado ? 'Sí' : 'No' }}
                              </v-chip>
                            </v-list-item-action>
                          </v-list-item>
                        </template>
                      </v-list>
                    </div>
                    <div
                      v-else-if="route.mapMode === 'planned'"
                      class="mt-3 d-flex align-start text-caption grey--text"
                    >
                      <v-icon x-small class="mr-2 mt-1">mdi-information-outline</v-icon>
                      <span>Los tiempos de paso GPS se muestran en recorridos desde mayo 2026 con ruta Traffilog.</span>
                    </div>
                  </template>
                </v-sheet>
                </div>

                <!-- Tabla de puntos GPS full-width debajo del mapa en pantallas anchas (>=1300px). -->
                <div
                  v-if="route.mapMode === 'traffilog_geofence' && route.gpsSample.length && isWideViewport"
                  class="gps-table-bottom pa-4"
                >
                  <div class="d-flex align-center mb-1">
                    <span class="text-subtitle-2">Muestra GPS</span>
                    <v-chip x-small class="ml-2" color="grey lighten-3">{{ route.gpsSample.length }} puntos</v-chip>
                    <span class="text-caption grey--text text--darken-1 ml-2">Selecciona una fila o el botón Centrar para ubicar el punto en el mapa.</span>
                  </div>
                  <v-simple-table dense class="gps-sample-table gps-sample-table--wide">
                    <template v-slot:default>
                      <caption class="d-sr-only">Puntos GPS del recorrido con número, hora, velocidad y kilometraje, con acción para centrar el mapa.</caption>
                      <thead>
                        <tr>
                          <th class="text-left" scope="col">#</th>
                          <th class="text-left" scope="col">Hora</th>
                          <th class="text-left" scope="col">Velocidad</th>
                          <th class="text-left" scope="col">Odómetro (km)</th>
                          <th class="text-right" scope="col">Acción</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(point, gpsIdx) in route.gpsSample"
                          :key="`gps-wide-${gpsIdx}-${point.at_local}`"
                        >
                          <td class="gps-num grey--text text--darken-1">{{ gpsIdx + 1 }}</td>
                          <td class="gps-num">{{ point.at_local || '-' }}</td>
                          <td class="gps-num">{{ fmtGpsNum(point.speed_kmh) }} km/h</td>
                          <td class="gps-num">{{ fmtGpsNum(point.odometer_km, 1) }}</td>
                          <td class="text-right">
                            <v-btn
                              x-small
                              outlined
                              color="blueKonect"
                              :aria-label="gpsRowAriaLabel(point, gpsIdx)"
                              @click="centerMapOnGpsSample(point)"
                            >
                              <v-icon x-small left>mdi-crosshairs-gps</v-icon>
                              Centrar
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <errormsg
            v-if="error"
            class="mt-4"
            :text="codeError || 'Ocurrió un error al consultar el servicio'"
            @close="
              error = false
              codeError = ''
            "
          />
        </v-card-text>
      </v-card>

      <!-- Modal Reporte Regio Ruta Extendido -->
      <v-dialog v-model="ui.modalReporte" max-width="420" persistent>
        <v-card class="rounded-lg">
          <v-card-title class="text-h6">
            <v-icon left color="pinkKonect">mdi-file-chart-outline</v-icon>
            Reporte Regio Ruta Extendido
          </v-card-title>
          <v-card-text class="pb-2">
            <v-select
              v-model="tipoReporte"
              :items="tipoReporteItems"
              item-text="text"
              item-value="value"
              label="Tipo de reporte"
              dense
              outlined
              hide-details
              prepend-inner-icon="mdi-calendar-range"
              class="mb-4"
            />
            <v-alert dense text type="info" class="text-caption mb-3" icon="mdi-information-outline">
              Este reporte resume corridas, kilómetros e importe por periodo. Con permiso de cumplimiento, el Excel agrega la hoja <strong>Detalle viajes</strong> con los mismos datos visibles en tabla (incluye diagnóstico GPS si aplica). También puedes usar <strong>Descargar resultados</strong> (CSV).
            </v-alert>
            <div class="text-subtitle-2 mb-2">Formato de descarga</div>
            <v-btn block outlined color="green darken-2" class="mb-2" :loading="loadingExcel" @click="generarReporteExcel(); ui.modalReporte = false">
              <v-icon left>mdi-file-excel-outline</v-icon>
              Excel con formato
            </v-btn>
            <v-btn block outlined color="red darken-2" :loading="loadingExcel" @click="generarReportePDF(); ui.modalReporte = false">
              <v-icon left>mdi-file-pdf-box</v-icon>
              PDF
            </v-btn>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="ui.modalReporte = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </v-main>
</template>

<script>
import moment from 'moment-timezone'
import _ from 'lodash'
import services from '@/utils/services'
import downloadjs from 'downloadjs'
import XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { errormsg } from '@/components'
import { gmapApi } from 'vue2-google-maps'

const REGIO_RT_EXT_FECHA_MIN = '2026-05-01'

function buildRegioExtDefaultFechas() {
  const min = moment(REGIO_RT_EXT_FECHA_MIN, 'YYYY-MM-DD')
  const today = moment().startOf('day')
  if (today.isBefore(min, 'day')) {
    const d = min.format('YYYY-MM-DD')
    return { fecha_inicio: d, fecha_fin: d }
  }
  return {
    fecha_inicio: moment.max(min, today.clone().subtract(6, 'days')).format('YYYY-MM-DD'),
    fecha_fin: today.format('YYYY-MM-DD')
  }
}

const REGIO_RT_EXT_FECHA_DEFAULTS = buildRegioExtDefaultFechas()
const PERM_EXT_LECTURA = 'CK_REPORTE_RR_EXT_LECTURA'
const PERM_CUMPLIMIENTO = 'CK_REPORTE_RR_EXT_CUMPLIMIENTO_LECTURA'
const PERM_DIAGNOSTICO_GPS = 'CK_REPORTE_RR_EXT_DIAGNOSTICO_GPS_LECTURA'
const PERM_CONCILIACION = 'CK_REPORTE_RR_CONCILIACION_LECTURA'
const REF_POINT_TYPE_LABELS = {
  IDA: 'Ida',
  INICIO: 'Inicio',
  RETORNO: 'Retorno',
  FIN: 'Fin',
  INTERMEDIO: 'Intermedio'
}

export default {
  name: 'ReporteRegioRutaExtendido',
  components: { errormsg },

  data: () => ({
    loading: false,
    loadingReports: false,
    loadingExcel: false,
    loadingClients: false,
    loadingRamales: false,
    map: {
      center: { lat: 25.689665, lng: -100.310619 },
      zoom: 13,
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      }
    },
    error: false,
    codeError: '',

    filtros: {
      fecha_inicio: REGIO_RT_EXT_FECHA_DEFAULTS.fecha_inicio,
      fecha_fin: REGIO_RT_EXT_FECHA_DEFAULTS.fecha_fin
    },

    selectedClienteId: null,
    clientItem: [],
    itemsAux: [],

    selectedRamalIds: [],
    ramalItems: [],

    items: [],
    search: '',
    searchDebounced: '',
    permisos: [],

    dialogs: { mapa: false },
    selectedItem: null,
    markerPos: null,
    _gmap: { map: null, marker: null, lastCenter: null },
    ui: { modalIni: false, modalFin: false, modalReporte: false, tmpIni: null, tmpFin: null },

    route: {
      loading: false,
      path: [],
      start: null,
      end: null,
      stops: [],
      referencePoints: [],
      salidaReal: null,
      llegadaReal: null,
      error: '',
      warning: '',
      mapMode: '',
      gpsSummary: null,
      gpsSample: []
    },

    viewportWidth: (typeof window !== 'undefined' && window.innerWidth) || 1280,

    tableKey: 0, // <-- NUEVO: para forzar re-render de la tabla si es necesario

    tipoReporte: 'diario',
    tipoReporteItems: [
      { text: 'Diario', value: 'diario' },
      { text: 'Semanal', value: 'semanal' },
      { text: 'Mensual', value: 'mensual' }
    ]
  }),

  created() {
    this.permisos = this.$session.get('permisos') || []
    // Aumenta el delay del debounce para evitar ejecuciones excesivas
    this._applySearch = _.debounce((v) => {
      this.searchDebounced = v
    }, 400) // Aumentado a 400ms
    this._onResize = _.debounce(() => {
      this.viewportWidth = (typeof window !== 'undefined' && window.innerWidth) || this.viewportWidth
    }, 150)
    this.loadClients()
  },

  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this._onResize, { passive: true })
    }
  },

  watch: {
    search(val) {
      // Limita el watch para evitar ejecuciones innecesarias
      if (this._applySearch) {
        this._applySearch(val)
      }
    },

    selectedClienteId() {
      this.selectedRamalIds = []
      this.ramalItems = []
      this.items = [] // <-- NUEVO: limpia los items al cambiar cliente
      this.search = '' // <-- NUEVO: limpia el búsqueda
      if (Number.isFinite(this.idclienteEff)) {
        this.loadRamales()
      }
    },

    'ui.modalIni'(open) {
      if (open) this.ui.tmpIni = this.filtros.fecha_inicio
    },

    'ui.modalFin'(open) {
      if (open) this.ui.tmpFin = this.filtros.fecha_fin
    }
  },

  computed: {
    google: gmapApi,
    isWideViewport() {
      return this.viewportWidth >= 1300
    },
    fechaMinReporte() {
      return REGIO_RT_EXT_FECHA_MIN
    },
    fechaMaxReporte() {
      return moment().format('YYYY-MM-DD')
    },
    canVerCumplimiento() {
      return this.hasPerm(PERM_CUMPLIMIENTO) || this.hasPerm(PERM_EXT_LECTURA)
    },
    canVerDiagnosticoGps() {
      return this.hasPerm(PERM_DIAGNOSTICO_GPS)
    },
    canConciliacion() {
      return this.hasPerm(PERM_CONCILIACION)
    },
    mapSalidaReal() {
      return this.route.salidaReal || this.selectedItem?.salida_ida_real || null
    },
    mapLlegadaReal() {
      return this.route.llegadaReal || this.selectedItem?.llegada_ida_real || null
    },
    headers() {
      const cols = [
        { text: 'Fecha', value: 'fecha_recorrido', align: 'start' },
        { text: 'Folio boleta', value: 'folio_boleta', align: 'start' },
        { text: 'Ramal', value: 'nombre_ramal', align: 'start' },
        { text: 'Tipo', value: 'tipo_recorrido_label', align: 'start', sortable: false },
        { text: 'Origen → Destino', value: 'origen_destino_sigue', align: 'start', sortable: false },
        { text: 'No. Económico', value: 'no_economico', align: 'start' },
        { text: 'Operador', value: 'operador', align: 'start' },
        { text: 'Nómina', value: 'num_nomina', align: 'start' },
        { text: 'Turno', value: 'turno', align: 'end' },
        { text: 'Vuelta', value: 'vuelta', align: 'end' },
        { text: 'Pasajeros', value: 'total_pasajeros', align: 'end' },
        { text: 'Km', value: 'kilometros', align: 'end' },
        { text: 'Salida ida Plan', value: 'plan_salida_ida', align: 'start' },
        { text: 'Llegada ida Plan', value: 'plan_llegada_ida', align: 'start' },
        { text: 'Salida ret. Plan', value: 'plan_salida_retorno', align: 'start' },
        { text: 'Llegada ret. Plan', value: 'plan_llegada_retorno', align: 'start' }
      ]
      if (this.canVerCumplimiento) {
        cols.push(
          { text: 'Salida ida Real', value: 'real_salida_ida', align: 'start' },
          { text: 'Cruce salida ida', value: 'cruce_salida_ida_ok', align: 'center', sortable: false },
          { text: 'Llegada ida Real', value: 'real_llegada_ida', align: 'start' },
          { text: 'Cruce llegada ida', value: 'cruce_llegada_ida_ok', align: 'center', sortable: false },
          { text: 'Salida ret. Real', value: 'real_salida_retorno', align: 'start' },
          { text: 'Cruce salida ret.', value: 'cruce_salida_retorno_ok', align: 'center', sortable: false },
          { text: 'Llegada ret. Real', value: 'real_llegada_retorno', align: 'start' },
          { text: 'Cruce llegada ret.', value: 'cruce_llegada_retorno_ok', align: 'center', sortable: false },
          { text: 'Frecuencia', value: 'frecuencia', align: 'start' },
          { text: 'Desfase llegada', value: 'desfase_llegada', align: 'start' }
        )
      }
      cols.push(
        { text: 'Comentarios', value: 'comentarios', align: 'center', sortable: false },
        { text: 'Acciones', value: 'actions', align: 'center', sortable: false }
      )
      return cols
    },
    exportColumns() {
      const cols = this.headers.filter((h) => h.value !== 'actions')
      cols.push(
        { text: 'Fuente tipo', value: '_fuente_tipo' },
        { text: 'Match origen', value: '_match_origen' },
        { text: 'Match destino', value: '_match_destino' },
        { text: 'Discrepancia tipo', value: '_discrepancia_tipo' }
      )
      if (this.canVerDiagnosticoGps && this.canVerCumplimiento) {
        cols.push(
          { text: 'Motivo sin salida GPS', value: '_diag_salida' },
          { text: 'Motivo sin llegada GPS', value: '_diag_llegada' }
        )
      }
      return cols
    },
    idclienteEff() {
      const ui = Number(this.selectedClienteId)
      return Number.isFinite(ui) && ui > 0 ? ui : NaN
    },
    isFiltroValido() {
      const { fecha_inicio, fecha_fin } = this.filtros
      const idclienteNum = this.idclienteEff
      const fechasOk = !!fecha_inicio && !!fecha_fin && String(fecha_inicio) <= String(fecha_fin)
      const clienteOk = Number.isFinite(idclienteNum) && idclienteNum > 0
      return fechasOk && clienteOk
    },
    itemsFiltered() {
      const addUid = (list) => list.map((item, i) => {
        if (!item._uid) {
          const folio = String(item?.folio_boleta || '').trim() || 'nf'
          const fecha = String(item?.fecha_recorrido || '').trim() || 'nd'
          const eco = String(item?.no_economico || '').trim() || 'ne'
          item._uid = `${folio}-${fecha}-${eco}-${i}`
        }
        return item
      })

      const q = String(this.searchDebounced || '')
        .toLowerCase()
        .trim()

      // Solo filtra si hay al menos 2 caracteres
      if (!q || q.length < 2) return addUid(this.items)

      // Usa try-catch para evitar errores que congelen la tabla
      try {
        return addUid(this.items.filter((item) => {
          // Verifica que item existe antes de acceder a sus propiedades
          if (!item) return false

          const searchableText = [
            item.folio_boleta,
            item.nombre_ramal,
            item.tipo_recorrido,
            item.tipo_recorrido_sigue,
            item.tipo_sigue_crudo,
            item.origen_sigue,
            item.destino_sigue,
            item.no_economico,
            item.operador,
            item.fecha_recorrido_fmt
          ]
            .filter((v) => v != null) // Filtra valores null/undefined
            .join(' ')
            .toLowerCase()

          return searchableText.includes(q)
        }))
      } catch (e) {
        console.error('Error en itemsFiltered:', e)
        return addUid(this.items) // Retorna items sin filtrar si hay error
      }
    }
  },

  beforeDestroy() {
    // Limpia el debounce
    if (this._applySearch) {
      this._applySearch.cancel()
    }

    if (typeof window !== 'undefined' && this._onResize) {
      window.removeEventListener('resize', this._onResize)
      this._onResize.cancel()
    }

    // Limpia el state
    this.items = []
    this.search = ''
    this.searchDebounced = ''
  },

  methods: {
    formatFechaDisplay(iso) {
      if (!iso) return ''
      const m = moment(String(iso).slice(0, 10), 'YYYY-MM-DD', true)
      return m.isValid() ? m.format('DD/MM/YYYY') : String(iso)
    },

    acceptFechaInicio() {
      const picked = this.ui.tmpIni
      if (!picked) {
        this.ui.modalIni = false
        return
      }
      this.filtros.fecha_inicio = picked
      if (!this.filtros.fecha_fin || String(picked) > String(this.filtros.fecha_fin)) {
        this.filtros.fecha_fin = picked
        this.ui.tmpFin = picked
      }
      this.$refs.dialogIni.save(picked)
    },

    acceptFechaFin() {
      const picked = this.ui.tmpFin
      if (!picked) {
        this.ui.modalFin = false
        return
      }
      this.filtros.fecha_fin = picked
      if (!this.filtros.fecha_inicio || String(picked) < String(this.filtros.fecha_inicio)) {
        this.filtros.fecha_inicio = picked
        this.ui.tmpIni = picked
      }
      this.$refs.dialogFin.save(picked)
    },

    hasPerm(permiso) {
      const per = this.permisos || []
      return Array.isArray(per) && per.includes(permiso)
    },

    irConciliacion() {
      if (!this.canConciliacion || !this.isFiltroValido) return
      const query = {
        fecha_inicio: this.filtros.fecha_inicio,
        fecha_fin: this.filtros.fecha_fin,
        idcliente: String(this.idclienteEff),
        consultar: '1'
      }
      if (Array.isArray(this.selectedRamalIds) && this.selectedRamalIds.length > 0) {
        query.idramal = this.selectedRamalIds.join(',')
      }
      this.$router.push({ name: 'conciliacionRegioRuta', query })
    },

    refPointTypeLabel(tipo) {
      return REF_POINT_TYPE_LABELS[tipo] || tipo || '-'
    },

    formatDistanciaMin(metros) {
      if (metros == null || !Number.isFinite(Number(metros))) return '-'
      return `${Math.round(Number(metros))} m`
    },

    fmtGpsNum(value, digits = 1) {
      if (value == null || !Number.isFinite(Number(value))) return '-'
      return Number(value).toFixed(digits)
    },

    fmtGpsOdometerRange(summary) {
      if (!summary) return '-'
      const start = summary.odometro_inicio_km
      const end = summary.odometro_fin_km
      if (start == null || end == null || !Number.isFinite(Number(start)) || !Number.isFinite(Number(end))) {
        return '-'
      }
      return `${this.fmtGpsNum(start, 1)} a ${this.fmtGpsNum(end, 1)}`
    },

    gpsRowAriaLabel(point, idx) {
      const hora = point && point.at_local ? point.at_local : 'sin hora'
      const vel = this.fmtGpsNum(point && point.speed_kmh)
      return `Centrar el mapa en el punto ${idx + 1}, ${hora}, ${vel} kilómetros por hora`
    },

    centerMapOnGpsSample(point) {
      if (!point || !Number.isFinite(point.lat) || !Number.isFinite(point.lng)) return
      const p = this.$refs.gmapDetalle?.$mapPromise
      if (!p || !this.google?.maps) return
      p.then((map) => {
        map.panTo({ lat: point.lat, lng: point.lng })
        if ((map.getZoom() || 0) < 15) map.setZoom(15)
      })
    },

    formatGpsDiagTooltip(diag, lado) {
      if (!diag) return ''
      const etiqueta = lado === 'salida' ? 'salida' : 'llegada'
      const punto = diag.punto || 'punto de referencia'
      const ventana =
        diag.ventana_desde && diag.ventana_hasta
          ? `${diag.ventana_desde} a ${diag.ventana_hasta}`
          : 'no disponible'
      const dist =
        diag.distancia_min_m != null
          ? `${diag.distancia_min_m} m`
          : 'sin dato'
      return (
        `Sin cruce GPS de ${etiqueta} en ${punto} (radio ${diag.radio_metros || 50} m). ` +
        `Ventana: ${ventana}. Distancia mínima en ventana: ${dist}.`
      )
    },

    formatComentarioMeta(c) {
      const autor = (c && c.autor_nombre) ? c.autor_nombre : 'Equipo Konect'
      let fecha = ''
      if (c && c.fecha_creacion) {
        const d = new Date(c.fecha_creacion)
        if (!Number.isNaN(d.getTime())) {
          fecha = d.toLocaleString('es-MX', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })
        }
      }
      return fecha ? `${autor} · ${fecha}` : autor
    },

    formatTripTypeLabel(value) {
      if (!value) return '-'
      const labels = {
        COMPLETO: 'Completo',
        MEDIA_VUELTA: 'Media vuelta',
        VUELTA_CORTA: 'Vuelta corta'
      }
      return labels[value] || value
    },

    formatFuenteTipo(value) {
      if (!value) return '-'
      const labels = {
        sigue: 'SIGUE',
        override_ramal: 'Override ramal',
        default_global: 'Default global',
        fallback_ramal: 'Fallback ramal',
        reprocess_override: 'Reproceso'
      }
      return labels[value] || value
    },

    formatMatchLabel(value) {
      if (!value) return '-'
      const labels = {
        nombre: 'nombre',
        tipo_punto: 'tipo punto',
        sin_match: 'sin match'
      }
      return labels[value] || value
    },

    hasTipoTooltip(item) {
      if (!item) return false
      return Boolean(
        item.origen_sigue ||
          item.destino_sigue ||
          item.fuente_tipo ||
          item.tipo_sigue_crudo ||
          item.discrepancia_tipo_ramal ||
          item.match_origen ||
          item.match_destino
      )
    },

    getExportCellValue(row, key) {
      if (key === 'fecha_recorrido') {
        return row.fecha_recorrido_fmt || row.fecha_recorrido || ''
      }
      if (key === 'tipo_recorrido_label') {
        const label = this.formatTripTypeLabel(
          row.tipo_recorrido || row.tipo_recorrido_sigue || row.tipo_sigue_crudo
        )
        if (row.discrepancia_tipo_ramal) return `${label} (discrepancia)`
        return label
      }
      if (key === 'origen_destino_sigue') {
        if (!row.origen_sigue && !row.destino_sigue) return '-'
        return `${row.origen_sigue || '-'} → ${row.destino_sigue || '-'}`
      }
      if (key === '_fuente_tipo') {
        return this.formatFuenteTipo(row.fuente_tipo)
      }
      if (key === '_match_origen') {
        return this.formatMatchLabel(row.match_origen)
      }
      if (key === '_match_destino') {
        return this.formatMatchLabel(row.match_destino)
      }
      if (key === '_discrepancia_tipo') {
        if (row.discrepancia_tipo_ramal == null) return '-'
        return row.discrepancia_tipo_ramal ? 'Sí' : 'No'
      }
      const cruceKeys = [
        'cruce_salida_ida_ok',
        'cruce_llegada_ida_ok',
        'cruce_salida_retorno_ok',
        'cruce_llegada_retorno_ok'
      ]
      if (cruceKeys.includes(key)) {
        const ok = row[key]
        if (ok == null) return '-'
        return ok ? 'Sí' : 'No'
      }
      if (key === '_diag_salida') {
        if (row.real_salida_ida || row.salida_ida_real || row.real_salida_retorno) return ''
        return row.diagnostico_gps?.salida
          ? this.formatGpsDiagTooltip(row.diagnostico_gps.salida, 'salida')
          : ''
      }
      if (key === '_diag_llegada') {
        if (row.real_llegada_retorno || row.real_llegada_ida || row.llegada_ida_real) return ''
        return row.diagnostico_gps?.llegada
          ? this.formatGpsDiagTooltip(row.diagnostico_gps.llegada, 'llegada')
          : ''
      }
      if (key === 'comentarios') {
        return Array.isArray(row.comentarios)
          ? row.comentarios
              .map((c) => (c && c.comentario ? String(c.comentario) : ''))
              .filter(Boolean)
              .join(' | ')
          : ''
      }
      const value = row[key]
      return value == null ? '' : value
    },

    _appendDetalleViajesSheet(workbook, filtros, clienteNombre) {
      if (!this.canVerCumplimiento) return

      const rows = this.itemsFiltered || []
      if (!rows.length) return

      const cols = this.exportColumns
      const ws = workbook.addWorksheet('Detalle viajes', {
        pageSetup: { paperSize: 9, orientation: 'landscape', fitToPage: true, fitToWidth: 1, fitToHeight: 0 }
      })

      const titleFont = { name: 'Arial', size: 11, bold: true }
      const headerFont = { name: 'Arial', size: 9, bold: true, color: { argb: 'FFFFFFFF' } }
      const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F3864' } }
      const dataFont = { name: 'Arial', size: 9 }

      ws.getCell('A1').value = 'Detalle de viajes'
      ws.getCell('A1').font = titleFont
      ws.getCell('A2').value = `Cliente: ${clienteNombre || '-'}`
      ws.getCell('A3').value = `Periodo: ${filtros.fecha_inicio || ''} a ${filtros.fecha_fin || ''}`

      const headerRow = 5
      cols.forEach((col, index) => {
        const cell = ws.getCell(headerRow, index + 1)
        cell.value = col.text
        cell.font = headerFont
        cell.fill = headerFill
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true }
      })

      rows.forEach((row, rowIndex) => {
        cols.forEach((col, colIndex) => {
          const cell = ws.getCell(headerRow + 1 + rowIndex, colIndex + 1)
          cell.value = this.getExportCellValue(row, col.value)
          cell.font = dataFont
          cell.alignment = { vertical: 'top', wrapText: col.value.startsWith('_diag_') }
        })
      })

      cols.forEach((col, index) => {
        const width = col.value.startsWith('_diag_') ? 48 : Math.max(12, String(col.text).length + 2)
        ws.getColumn(index + 1).width = width
      })
    },

    sortReferencePoints(points) {
      return [...(points || [])].sort((a, b) => {
        const aCross = Boolean(a.cruzado)
        const bCross = Boolean(b.cruzado)
        if (aCross && bCross) {
          return (a.orden_paso ?? 999) - (b.orden_paso ?? 999)
        }
        if (aCross !== bCross) return aCross ? -1 : 1
        return String(a.nombre || a.tipo_punto || '').localeCompare(
          String(b.nombre || b.tipo_punto || ''),
          'es'
        )
      })
    },

    // ---- Helpers GeoJSON y URLs
    geojsonToPath(geo) {
      if (!geo || !geo.type || !geo.coordinates) return []
      const toLatLng = (pair) => {
        const [lng, lat] = pair || []
        return Number.isFinite(lat) && Number.isFinite(lng) ? { lat: Number(lat), lng: Number(lng) } : null
      }
      if (geo.type === 'LineString') {
        return (geo.coordinates || []).map(toLatLng).filter(Boolean)
      }
      if (geo.type === 'MultiLineString') {
        return (geo.coordinates || []).flatMap((line) => (line || []).map(toLatLng)).filter(Boolean)
      }
      return []
    },

    _buildMapRegRtUrls(base, id) {
      const b = String(base || 'mapRegRt/').trim()
      const be = b.endsWith('/') ? b : b + '/'
      const enc = encodeURIComponent(String(id))
      return [
        `${be}${enc}`, // GET /mapRegRt/:id
        `${b}?idrecorrido=${enc}` // GET /mapRegRt?idrecorrido=:id
      ]
    },

    normalizaFecha(str) {
      const m = moment(str, ['DD/MM/YYYY', 'YYYY-MM-DD', 'YYYY/MM/DD'], true)
      return m.isValid() ? m.format('DD/MM/YYYY') : str || '-'
    },

    async loadClients() {
      this.loadingClients = true
      try {
        const res = await services.ws('get', 'clients')
        this.itemsAux = Array.isArray(res?.data) ? res.data : []
        this.clientItem = this.itemsAux
          .map((c) => ({
            text: c.nombre_comercial,
            value: Number(c.idcliente),
            ext: c.idcliente_externo
          }))
          .filter((o) => Number.isFinite(o.value) && o.value > 0)
      } catch (error) {
        this.error = true
        this.codeError = _.get(error, 'response.data.message', 'No se pudieron cargar los clientes')
      } finally {
        this.loadingClients = false
      }
    },

    async loadRamales() {
      const idclienteNum = this.idclienteEff
      if (!Number.isFinite(idclienteNum)) return
      this.loadingRamales = true
      try {
        const baseUrl = _.get(services, 'routes.listRam', null)
        let resp
        if (baseUrl) {
          resp = await this.axios.get(`${baseUrl}${idclienteNum}`)
        } else {
          resp = await services.ws('get', `listRam/${idclienteNum}`)
        }

        const data = Array.isArray(resp?.data) ? resp.data : Array.isArray(resp?.data?.data) ? resp.data.data : []

        this.ramalItems = (data || [])
          .map((r) => ({
            text: r.nombre_ramal || r.nombre || `Ramal ${r.idramal ?? ''}`,
            value: Number(r.idramal ?? r.id_ramal ?? r.id) || null
          }))
          .filter((x) => Number.isFinite(x.value))
          .sort((a, b) => a.text.localeCompare(b.text, 'es'))
      } catch (e) {
        this.ramalItems = []
        this.error = true
        this.codeError = _.get(e, 'response.data.message', 'No se pudieron cargar los ramales')
      } finally {
        this.loadingRamales = false
      }
    },

    async fetchResumen() {
      try {
        this.loading = true
        this.error = false

        const idclienteNum = this.idclienteEff
        if (!Number.isFinite(idclienteNum) || idclienteNum <= 0) {
          this.error = true
          this.codeError = 'Debes seleccionar un cliente válido.'
          return
        }

        const payload = {
          idcliente: idclienteNum,
          fecha_inicio: this.filtros.fecha_inicio,
          fecha_fin: this.filtros.fecha_fin,
          idramal: Array.isArray(this.selectedRamalIds) && this.selectedRamalIds.length > 0 ? this.selectedRamalIds : []
        }

        const url = _.get(services, 'routes.repRegRt') || _.get(services, 'routes.resRd')
        const resp = url ? await this.axios.post(url, payload) : await services.ws('post', 'repRegRt', payload)

        const arr = Array.isArray(resp?.data)
          ? resp.data
          : Array.isArray(resp?.data?.data)
          ? resp.data.data
          : resp?.data
          ? [resp.data]
          : []

        // Mapea los datos de forma más segura
        this.items = (arr || []).map((r, idx) => {
          const row = {
            _index: idx, // <-- NUEVO: índice único interno
            folio_boleta: _.get(r, 'folio_boleta', ''),
            vuelta: Number(_.get(r, 'vuelta', 0)),
            total_pasajeros: Number(_.get(r, 'total_pasajeros', 0)),
            no_economico: _.get(r, 'no_economico', ''),
            num_nomina: _.get(r, 'num_nomina', ''),
            salida_ida_plan: _.get(r, 'salida_ida_plan', ''),
            llegada_ida_plan: _.get(r, 'llegada_ida_plan', ''),
            salida_ida_real: _.get(r, 'salida_ida_real', ''),
            llegada_ida_real: _.get(r, 'llegada_ida_real', ''),
            // Vuelta completa (ida + retorno)
            plan_salida_ida: _.get(r, 'plan_salida_ida', _.get(r, 'salida_ida_plan', '')),
            plan_llegada_ida: _.get(r, 'plan_llegada_ida', _.get(r, 'llegada_ida_plan', '')),
            plan_salida_retorno: _.get(r, 'plan_salida_retorno', _.get(r, 'salida_retorno_plan', '')),
            plan_llegada_retorno: _.get(r, 'plan_llegada_retorno', _.get(r, 'llegada_retorno_plan', '')),
            real_salida_ida: _.get(r, 'real_salida_ida', _.get(r, 'salida_ida_real', '')),
            real_llegada_ida: _.get(r, 'real_llegada_ida', _.get(r, 'llegada_ida_real', '')),
            real_salida_retorno: _.get(r, 'real_salida_retorno', _.get(r, 'salida_retorno_real', '')),
            real_llegada_retorno: _.get(r, 'real_llegada_retorno', _.get(r, 'llegada_retorno_real', '')),
            cruce_salida_ida_ok: _.get(r, 'cruce_salida_ida_ok', _.get(r, 'cruce_inicio_ok', null)),
            cruce_llegada_ida_ok: _.get(r, 'cruce_llegada_ida_ok', _.get(r, 'cruce_fin_ok', null)),
            cruce_salida_retorno_ok: _.get(r, 'cruce_salida_retorno_ok', null),
            cruce_llegada_retorno_ok: _.get(r, 'cruce_llegada_retorno_ok', null),
            diagnostico_gps: _.get(r, 'diagnostico_gps', null),
            tipo_recorrido: _.get(r, 'tipo_recorrido', null),
            tipo_recorrido_sigue: _.get(r, 'tipo_recorrido_sigue', null),
            tipo_sigue_crudo: _.get(r, 'tipo_sigue_crudo', null),
            origen_sigue: _.get(r, 'origen_sigue', null),
            destino_sigue: _.get(r, 'destino_sigue', null),
            fuente_tipo: _.get(r, 'fuente_tipo', null),
            discrepancia_tipo_ramal: _.get(r, 'discrepancia_tipo_ramal', null),
            match_origen: _.get(r, 'match_origen', null),
            match_destino: _.get(r, 'match_destino', null),
            fecha_recorrido: _.get(r, 'fecha_recorrido', ''),
            frecuencia: _.get(r, 'frecuencia', ''),
            desfase_llegada: _.get(r, 'desfase_llegada', ''),
            kilometros: Number(_.get(r, 'kilometros', 0)),
            turno: Number(_.get(r, 'turno', 0)),
            nombre_ramal: _.get(r, 'nombre_ramal', ''),
            operador: _.get(r, 'operador', ''),
            idrecorrido: _.get(r, 'idrecorrido', _.get(r, 'id_recorrido', null)),
            comentarios: Array.isArray(_.get(r, 'comentarios', []))
              ? _.get(r, 'comentarios', [])
              : []
          }
          row.fecha_recorrido_fmt = this.normalizaFecha(row.fecha_recorrido)

          // Crea el texto de búsqueda de forma más segura
          const lower = (v) => String(v ?? '').toLowerCase()
          const qParts = [
            row.folio_boleta,
            row.fecha_recorrido_fmt,
            row.nombre_ramal,
            row.tipo_recorrido,
            row.tipo_recorrido_sigue,
            row.tipo_sigue_crudo,
            row.origen_sigue,
            row.destino_sigue,
            row.no_economico,
            row.operador,
            row.num_nomina,
            row.turno,
            row.vuelta,
            row.total_pasajeros,
            row.kilometros
          ]
          qParts.push(
            row.plan_salida_ida,
            row.plan_llegada_ida,
            row.plan_salida_retorno,
            row.plan_llegada_retorno
          )
          if (this.canVerCumplimiento) {
            qParts.push(
              row.real_salida_ida,
              row.real_llegada_ida,
              row.real_salida_retorno,
              row.real_llegada_retorno,
              row.frecuencia,
              row.desfase_llegada
            )
          }
          row._q = qParts
            .map(lower)
            .join('|')

          return row
        })

        // Fuerza un re-render de la tabla para evitar estados inconsistentes
        this.tableKey++

        // Limpia la búsqueda después de consultar
        this.$nextTick(() => {
          this.search = ''
          this.searchDebounced = ''
        })
      } catch (e) {
        this.error = true
        this.codeError = _.get(e, 'response.data.message', _.get(e, 'message', 'Error al consultar'))
      } finally {
        this.loading = false
      }
    },

    async fetchRuta(idrecorrido) {
      const id = String(idrecorrido || '').trim()
      if (!id) {
        this.route = {
          loading: false,
          path: [],
          start: null,
          end: null,
          stops: [],
          referencePoints: [],
          salidaReal: null,
          llegadaReal: null,
          error: 'idrecorrido inválido',
          warning: '',
          mapMode: '',
          gpsSummary: null,
          gpsSample: []
        }
        return
      }

      this.route.loading = true
      this.route.error = ''
      this.route.warning = ''
      this.route.path = []
      this.route.start = null
      this.route.end = null
      this.route.stops = []
      this.route.referencePoints = []
      this.route.salidaReal = null
      this.route.llegadaReal = null
      this.route.mapMode = ''
      this.route.gpsSummary = null
      this.route.gpsSample = []

      try {
        const base = _.get(services, 'routes.mapRegRtExt', _.get(services, 'routes.mapRegRt', 'georute/'))
        const be = base.endsWith('/') ? base : base + '/'
        const url = `${be}${encodeURIComponent(id)}`
        const resp = await this.axios.get(url)

        const raw = resp?.data?.data ?? resp?.data ?? {}
        const root = Array.isArray(raw) ? raw[0] : raw
        const geo = _.get(root, 'georuta.georuta') || _.get(root, 'georuta') || root
        const pathFromApi = Array.isArray(root.path_latlng) ? root.path_latlng : null

        const coords = pathFromApi && pathFromApi.length >= 2
          ? pathFromApi
          : this.geojsonToPath(geo)

        this.route.mapMode = root.map_mode || ''

        if (!Array.isArray(coords) || coords.length < 2) {
          this.route.error = root.mensaje_error || 'No se encontró la georuta para el recorrido.'
          return
        }

        this.route.path = coords
        const startMarker = root.start_marker
        const endMarker = root.end_marker
        this.route.start =
          startMarker && Number.isFinite(startMarker.lat) && Number.isFinite(startMarker.lng)
            ? { lat: startMarker.lat, lng: startMarker.lng }
            : coords[0]
        this.route.end =
          endMarker && Number.isFinite(endMarker.lat) && Number.isFinite(endMarker.lng)
            ? { lat: endMarker.lat, lng: endMarker.lng }
            : coords[coords.length - 1]
        this.route.salidaReal = startMarker?.crossed_at_local || null
        this.route.llegadaReal = endMarker?.crossed_at_local || null
        this.route.gpsSummary = root.gps_summary || null
        this.route.gpsSample = Array.isArray(root.gps_sample) ? root.gps_sample : []

        if (root.mensaje_error) {
          this.route.warning = root.mensaje_error
        }

        const refPoints = Array.isArray(root.reference_points) ? root.reference_points : []
        const sortedRefPoints = this.sortReferencePoints(refPoints)
        this.route.referencePoints = sortedRefPoints.map((p) => ({
          idramal_punto_referencia: p.idramal_punto_referencia,
          nombre: p.nombre,
          tipo_punto: p.tipo_punto,
          cruzado: Boolean(p.cruzado),
          cruzado_at_local: p.cruzado_at_local || null,
          orden_paso: p.orden_paso ?? null,
          distancia_min_metros: p.distancia_min_metros ?? null
        }))
        this.route.stops = sortedRefPoints
          .filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng))
          .map((p) => ({
            lat: p.lat,
            lng: p.lng,
            cruzado: Boolean(p.cruzado),
            title: `${p.nombre || p.tipo_punto}${p.cruzado_at_local ? ' (' + p.cruzado_at_local + ')' : ''}`
          }))

        // Fit bounds
        this.$nextTick(() => {
          const p = this.$refs.gmapDetalle?.$mapPromise
          if (p && this.google?.maps) {
            p.then((map) => {
              const bounds = new this.google.maps.LatLngBounds()
              this.route.path.forEach((c) => bounds.extend(c))
              map.fitBounds(bounds)
              const once = this.google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
                if (map.getZoom() > 18) map.setZoom(18)
              })
              setTimeout(() => this.google.maps.event.removeListener(once), 800)
            })
          }
        })
      } catch (e) {
        const backendMsg = _.get(e, 'response.data.message')
        this.route.error = backendMsg || 'No se pudo cargar la ruta del recorrido.'
      } finally {
        this.route.loading = false
      }
    },

    getUniqueKey(item, index) {
      // Clave más robusta que garantiza unicidad
      const folio = String(item?.folio_boleta || '').trim() || 'no-folio'
      const fecha = String(item?.fecha_recorrido || '').trim() || 'no-fecha'
      const eco = String(item?.no_economico || '').trim() || 'no-eco'
      return `${folio}-${fecha}-${eco}-${index}`
    },

    openMapa(item) {
      this.selectedItem = item || null

      const { lat, lng } = this.getCoordsFromItem(item)
      this.markerPos = Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : this.map.center

      this.dialogs.mapa = true

      this.$nextTick(() => {
        const p = this.$refs.gmapDetalle?.$mapPromise
        if (p) {
          setTimeout(() => {
            p.then((map) => {
              if (this.google?.maps) {
                this.google.maps.event.trigger(map, 'resize')
                map.setCenter(this.markerPos || this.map.center)
              }
            })
          }, 150)
        }
      })

      const idrec = String(_.get(item, 'idrecorrido', _.get(item, 'id_recorrido', ''))).trim()
      if (!idrec) {
        this.route.error = 'Este registro no trae idrecorrido.'
        return
      }
      this.fetchRuta(idrec)
    },

    onCloseMapa() {
      this.dialogs.mapa = false
      this.route = {
        loading: false,
        path: [],
        start: null,
        end: null,
        stops: [],
        referencePoints: [],
        salidaReal: null,
        llegadaReal: null,
        error: '',
        mapMode: ''
      }
    },

    getCoordsFromItem(item) {
      const lat = Number(item?.lat ?? item?.latitud ?? item?.latitude)
      const lng = Number(item?.lng ?? item?.longitud ?? item?.longitude)
      return { lat, lng }
    },

    toCsvRow(arr) {
      return arr
        .map((v) => {
          const s = String(v ?? '').replace(/"/g, '""')
          return /[",\n]/.test(s) ? `"${s}"` : s
        })
        .join(',')
    },

    async generarReporteExcel() {
      try {
        this.loadingExcel = true
        this.error = false

        const idclienteNum = this.idclienteEff
        if (!Number.isFinite(idclienteNum) || idclienteNum <= 0) {
          this.error = true
          this.codeError = 'Debes seleccionar un cliente válido.'
          return
        }

        const payload = {
          idcliente: idclienteNum,
          fecha_inicio: this.filtros.fecha_inicio,
          fecha_fin: this.filtros.fecha_fin,
          idramal: Array.isArray(this.selectedRamalIds) && this.selectedRamalIds.length > 0 ? this.selectedRamalIds : []
        }

        const resp = await services.ws('post', 'repRegRtReport', payload)
        if (!resp || !resp.ok) {
          this.error = true
          this.codeError = _.get(resp, 'message', 'Error al obtener datos del reporte')
          return
        }

        const data = resp.data
        const rutas = data?.rutas || []
        const totales = data?.totales || {}
        const filtros = data?.filtros || {}

        // Find client name
        const clienteObj = this.clientItem.find((c) => c.value === idclienteNum)
        const clienteNombre = clienteObj?.text || ''

        // Build the Excel worksheet
        await this._buildExcel(rutas, totales, filtros, clienteNombre)
      } catch (e) {
        this.error = true
        this.codeError = _.get(e, 'response.data.message', _.get(e, 'message', 'Error al generar reporte'))
      } finally {
        this.loadingExcel = false
      }
    },

    async generarReportePDF() {
      try {
        this.loadingExcel = true
        this.error = false

        const idclienteNum = this.idclienteEff
        if (!Number.isFinite(idclienteNum) || idclienteNum <= 0) {
          this.error = true
          this.codeError = 'Debes seleccionar un cliente válido.'
          return
        }

        const payload = {
          idcliente: idclienteNum,
          fecha_inicio: this.filtros.fecha_inicio,
          fecha_fin: this.filtros.fecha_fin,
          idramal: Array.isArray(this.selectedRamalIds) && this.selectedRamalIds.length > 0 ? this.selectedRamalIds : []
        }

        const resp = await services.ws('post', 'repRegRtReport', payload)
        if (!resp || !resp.ok) {
          this.error = true
          this.codeError = _.get(resp, 'message', 'Error al obtener datos del reporte')
          return
        }

        const data = resp.data
        const rutas = data?.rutas || []
        const totales = data?.totales || {}
        const filtros = data?.filtros || {}

        const clienteObj = this.clientItem.find((c) => c.value === idclienteNum)
        const clienteNombre = clienteObj?.text || ''

        await this._buildPDF(rutas, totales, filtros, clienteNombre)
      } catch (e) {
        console.error('Error generarReportePDF:', e)
        this.error = true
        this.codeError = _.get(e, 'response.data.message', _.get(e, 'message', 'Error al generar PDF'))
      } finally {
        this.loadingExcel = false
      }
    },

    _getReportTitle() {
      const labels = { diario: 'DIARIO', semanal: 'SEMANAL', mensual: 'MENSUAL' }
      return `REPORTE ${labels[this.tipoReporte] || 'DIARIO'} DE RECORRIDOS`
    },

    _groupDataByPeriod(rutas, tipo) {
      const periodKey = (fecha) => {
        const m = moment(fecha, ['YYYY-MM-DD', 'DD/MM/YYYY'])
        if (!m.isValid()) return 'sin-fecha'
        if (tipo === 'diario') return m.format('YYYY-MM-DD')
        if (tipo === 'semanal') return `${m.isoWeekYear()}-W${String(m.isoWeek()).padStart(2, '0')}`
        return m.format('YYYY-MM')
      }

      const periodLabel = (key) => {
        if (tipo === 'diario') return moment(key, 'YYYY-MM-DD').format('DD-MM-YYYY')
        if (tipo === 'semanal') {
          const weekNum = key.split('-W')[1]
          return `Sem ${parseInt(weekNum, 10)}`
        }
        const m = moment(key, 'YYYY-MM')
        return m.isValid() ? m.locale('es').format('MMMM YYYY').replace(/^\w/, c => c.toUpperCase()) : key
      }

      const periodsSet = new Set()
      rutas.forEach(ruta => {
        (ruta.ramales || []).forEach(ramal => {
          (ramal.recorridos || []).forEach(rec => {
            periodsSet.add(periodKey(rec.fecha))
          })
        })
      })

      const sortedKeys = [...periodsSet].sort()

      return sortedKeys.map(pk => {
        const filteredRutas = rutas.map(ruta => {
          const filteredRamales = (ruta.ramales || []).map(ramal => {
            const filteredRecs = (ramal.recorridos || []).filter(rec => periodKey(rec.fecha) === pk)
            // For weekly/monthly, aggregate recorridos by no_economico
            let finalRecs = filteredRecs
            if (tipo !== 'diario' && filteredRecs.length > 0) {
              const byEco = {}
              filteredRecs.forEach(rec => {
                const eco = rec.no_economico || ''
                if (!byEco[eco]) {
                  byEco[eco] = { ...rec, corridas: 0, km: 0, importe: 0 }
                }
                byEco[eco].corridas += rec.corridas || 1
                byEco[eco].km += rec.km || 0
                byEco[eco].importe += rec.importe || 0
              })
              finalRecs = Object.values(byEco)
            }
            return { ...ramal, recorridos: finalRecs }
          }).filter(r => r.recorridos.length > 0)

          let totalCorridas = 0
          let subtotalKm = 0
          let subtotalImporte = 0
          filteredRamales.forEach(r => {
            r.recorridos.forEach(rec => {
              totalCorridas += rec.corridas || 1
              subtotalKm += rec.km || 0
              subtotalImporte += rec.importe || 0
            })
          })

          return {
            ...ruta,
            ramales: filteredRamales,
            total_corridas: totalCorridas,
            subtotal_km: subtotalKm,
            subtotal_importe: subtotalImporte
          }
        }).filter(r => r.ramales.length > 0)

        let totalImporte = 0
        let totalKm = 0
        let totalCorridas = 0
        filteredRutas.forEach(r => {
          totalImporte += r.subtotal_importe || 0
          totalKm += r.subtotal_km || 0
          totalCorridas += r.total_corridas || 0
        })

        // Compute period date range
        let fechaInicio, fechaFin
        if (tipo === 'diario') {
          fechaInicio = moment(pk, 'YYYY-MM-DD')
          fechaFin = fechaInicio.clone()
        } else if (tipo === 'semanal') {
          const [year, week] = pk.split('-W').map(Number)
          fechaInicio = moment().isoWeekYear(year).isoWeek(week).startOf('isoWeek')
          fechaFin = fechaInicio.clone().endOf('isoWeek')
        } else {
          fechaInicio = moment(pk, 'YYYY-MM').startOf('month')
          fechaFin = fechaInicio.clone().endOf('month')
        }

        return {
          key: pk,
          label: periodLabel(pk),
          fechaInicio: fechaInicio.format('DD/MM/YYYY'),
          fechaFin: fechaFin.format('DD/MM/YYYY'),
          rutas: filteredRutas,
          totales: { importe: totalImporte, km: totalKm, corridas: totalCorridas }
        }
      })
    },

    async _buildExcel(rutas, totales, filtros, clienteNombre) {
      const ExcelJS = (await import(/* webpackChunkName: "exceljs" */ 'exceljs')).default || await import('exceljs')
      const workbook = new ExcelJS.Workbook()

      // --- Load logos from public folder (once per workbook) ---
      const [logoGobBuf, logoSecBuf] = await Promise.all([
        fetch('/img/logogobmty.png').then(r => r.arrayBuffer()),
        fetch('/img/logoregioruta.png').then(r => r.arrayBuffer()),
      ])
      const logoGobId = workbook.addImage({ buffer: logoGobBuf, extension: 'png' })
      const logoSecId = workbook.addImage({ buffer: logoSecBuf, extension: 'png' })

      // --- Group data by period ---
      const periods = this._groupDataByPeriod(rutas, this.tipoReporte)
      const totalSheets = periods.length
      const reportTitle = this._getReportTitle()

      periods.forEach((period, idx) => {
      const periodRutas = period.rutas
      const sheetNum = idx + 1
      const sheetName = period.label.substring(0, 31)
      const ws = workbook.addWorksheet(sheetName, {
        pageSetup: { paperSize: 9, orientation: 'landscape', fitToPage: true, fitToWidth: 1, fitToHeight: 0 }
      })

      // --- Column widths ---
      ws.columns = [
        { width: 5 },   // A - No.
        { width: 44 },  // B - CONCEPTO
        { width: 8 },   // C - UNIDAD
        { width: 14 },  // D - PRECIO UNITARIO
        { width: 12 },  // E - No. ECO
        { width: 14 },  // F - No. REPORTE
        { width: 14 },  // G - PERIODO INICIO
        { width: 14 },  // H - PERIODO FINAL
        { width: 11 },  // I - CORRIDAS
        { width: 12 },  // J - Km
        { width: 16 },  // K - IMPORTE
      ]

      // --- Styles ---
      const titleFont = { name: 'Arial', size: 12, bold: true }
      const subtitleFont = { name: 'Arial', size: 10, bold: true }
      const headerFont = { name: 'Arial', size: 8, bold: true, color: { argb: 'FFFFFFFF' } }
      const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F3864' } }
      const dataFont = { name: 'Arial', size: 8 }
      const subtotalFont = { name: 'Arial', size: 8, bold: true, color: { argb: 'FFFFFFFF' } }
      const subtotalFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2E5599' } }
      const centerAlign = { horizontal: 'center', vertical: 'middle' }
      const rightAlign = { horizontal: 'right', vertical: 'middle' }
      const leftAlign = { horizontal: 'left', vertical: 'middle' }
      const thin = { style: 'thin' }
      const border = { top: thin, left: thin, bottom: thin, right: thin }

      const fmtDate = (d) => moment(d, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY')
      const fmtMoney = (n) => Number((n || 0).toFixed(2))
      const fmtKm = (n) => Number((n || 0).toFixed(2))
      // ============ HEADER (rows 1-3) ============
      ws.addImage(logoGobId, { tl: { col: 0, row: 0 }, ext: { width: 150, height: 55 } })
      ws.addImage(logoSecId, { tl: { col: 9.3, row: 0 }, ext: { width: 175, height: 52 } })

      ws.mergeCells('C1:I1')
      const c1 = ws.getCell('C1')
      c1.value = 'SERVICIO DE TRANSPORTACIÓN REGIO RUTA'
      c1.font = titleFont
      c1.alignment = centerAlign

      ws.mergeCells('C2:I2')
      const c2 = ws.getCell('C2')
      c2.value = reportTitle
      c2.font = subtitleFont
      c2.alignment = centerAlign

      ws.getRow(1).height = 30
      ws.getRow(2).height = 25
      ws.getRow(3).height = 8 // spacer

      // ============ COLUMN HEADERS (rows 4-5) ============
      // Row 4 main headers — merge single-column headers across both rows
      const singleCols = [1, 2, 3, 4, 5, 6, 11] // A,B,C,D,E,F,K
      singleCols.forEach(c => {
        const letter = ws.getColumn(c).letter
        ws.mergeCells(`${letter}4:${letter}5`)
      })
      ws.mergeCells('G4:H4') // PERIODO
      ws.mergeCells('I4:J4') // RECORRIDO

      const headerRow4 = ['No.', 'CONCEPTO', 'UNIDAD', 'PRECIO\nUNITARIO', 'No. ECO', 'No. REPORTE', 'PERIODO', '', 'RECORRIDO', '', 'IMPORTE']
      headerRow4.forEach((txt, i) => {
        const cell = ws.getCell(4, i + 1)
        cell.value = txt
        cell.font = headerFont
        cell.fill = headerFill
        cell.alignment = { ...centerAlign, wrapText: true }
        cell.border = border
      })
      const subHeaders = [null, null, null, null, null, null, 'INICIO', 'FINAL', 'CORRIDAS', 'Km', null]
      subHeaders.forEach((txt, i) => {
        const cell = ws.getCell(5, i + 1)
        if (txt) cell.value = txt
        cell.font = headerFont
        cell.fill = headerFill
        cell.alignment = centerAlign
        cell.border = border
      })
      ws.getRow(4).height = 24
      ws.getRow(5).height = 18

      // ============ DATA ROWS ============
      let row = 6
      let acumuladoKm = 0
      let acumuladoImporte = 0
      let acumuladoCorridas = 0

      periodRutas.forEach((ruta, ri) => {
        let rutaRowNum = 1

        ;(ruta.ramales || []).forEach((ramal) => {
          const letraRamal = (ramal.nombre_ramal || '').charAt(0).toUpperCase() || String(ri + 1)

          ;(ramal.recorridos || []).forEach((rec) => {
            const m = moment(rec.fecha, ['YYYY-MM-DD', 'DD/MM/YYYY'])
            const ecoDigits = (rec.no_economico || '').match(/^\d+/)?.[0] || ''
            const noReporte = `${m.format('YYMM')}-${ecoDigits}`
            const isDaily = this.tipoReporte === 'diario'
            const r = ws.getRow(row)
            r.getCell(1).value = rutaRowNum
            r.getCell(2).value = `Servicio de transportación integral en la Ruta ${letraRamal}`
            r.getCell(3).value = 'Km'
            r.getCell(4).value = fmtMoney(ramal.costo_km)
            r.getCell(5).value = rec.no_economico || ''
            r.getCell(6).value = noReporte
            r.getCell(7).value = isDaily ? fmtDate(rec.fecha) : period.fechaInicio
            r.getCell(8).value = isDaily ? fmtDate(rec.fecha) : period.fechaFin
            r.getCell(9).value = rec.corridas || 1
            r.getCell(10).value = fmtKm(rec.km)
            r.getCell(11).value = fmtMoney(rec.importe)

            for (let c = 1; c <= 11; c++) {
              const cell = r.getCell(c)
              cell.font = dataFont
              cell.border = border
              if ([1, 3, 9].includes(c)) cell.alignment = centerAlign
              else if (c === 4) { cell.alignment = rightAlign; cell.numFmt = '$#,##0.00' }
              else if (c === 10) { cell.alignment = rightAlign; cell.numFmt = '#,##0.00' }
              else if (c === 11) { cell.alignment = rightAlign; cell.numFmt = '$#,##0.00' }
              else cell.alignment = leftAlign
            }
            rutaRowNum++
            row++
          })
        })

        // --- Subtotal row per ruta (blue highlight) ---
        // Derive ruta letter from first ramal's nombre_ramal
        const letraRuta = ((ruta.ramales || [])[0]?.nombre_ramal || '').charAt(0).toUpperCase() || String(ri + 1)
        const subR = ws.getRow(row)
        ws.mergeCells(`A${row}:H${row}`)
        subR.getCell(1).value = `TOTAL DE CORRIDAS RUTA ${letraRuta}, KM Y SUBTOTAL`
        subR.getCell(9).value = ruta.total_corridas || 0
        subR.getCell(10).value = fmtKm(ruta.subtotal_km)
        subR.getCell(11).value = fmtMoney(ruta.subtotal_importe)

        for (let c = 1; c <= 11; c++) {
          const cell = subR.getCell(c)
          cell.font = subtotalFont
          cell.fill = subtotalFill
          cell.border = border
          if (c === 11) { cell.alignment = rightAlign; cell.numFmt = '$#,##0.00' }
          else if (c >= 9) { cell.alignment = rightAlign; cell.numFmt = '#,##0.00' }
          else cell.alignment = leftAlign
        }
        subR.height = 18

        acumuladoKm += ruta.subtotal_km || 0
        acumuladoImporte += ruta.subtotal_importe || 0
        acumuladoCorridas += ruta.total_corridas || 0
        row++
      })

      // ============ EMPTY + SUBTOTAL ============
      row += 2
      ws.mergeCells(`A${row}:J${row}`)
      ws.getCell(`J${row}`).alignment = rightAlign
      ws.getCell(`K${row}`).value = fmtMoney(acumuladoImporte)
      ws.getCell(`K${row}`).font = { name: 'Arial', size: 10, bold: true }
      ws.getCell(`K${row}`).numFmt = '$#,##0.00'
      ws.getCell(`K${row}`).alignment = rightAlign
      ws.getCell(`K${row}`).border = border

      // SUB-TOTAL label
      ws.getCell(`I${row}`).value = 'SUB-TOTAL'
      ws.getCell(`I${row}`).font = { name: 'Arial', size: 10, bold: true }
      ws.getCell(`I${row}`).alignment = rightAlign
      row++

      // ACUMULADO VALOR DE EST. box
      row++
      ws.mergeCells(`I${row}:J${row + 1}`)
      const acumLabel = ws.getCell(`I${row}`)
      acumLabel.value = 'ACUMULADO\nVALOR DE EST.'
      acumLabel.font = { name: 'Arial', size: 9, bold: true }
      acumLabel.alignment = { ...centerAlign, wrapText: true }
      acumLabel.border = border

      ws.mergeCells(`K${row}:K${row + 1}`)
      const acumVal = ws.getCell(`K${row}`)
      acumVal.value = fmtMoney(acumuladoImporte)
      acumVal.font = { name: 'Arial', size: 10, bold: true }
      acumVal.numFmt = '$#,##0.00'
      acumVal.alignment = centerAlign
      acumVal.border = border

      // Ensure border renders on merged area bottom row
      ws.getCell(`I${row + 1}`).border = border
      ws.getCell(`K${row + 1}`).border = border
      row += 3

      // ============ SIGNATURE BLOCKS ============
      // Block 1: MONITOREO
      ws.mergeCells(`A${row}:C${row}`)
      const sig1Title = ws.getCell(`A${row}`)
      sig1Title.value = 'MONITOREO DEL SERVICIO\nKONECT LOGÍSTICA INTEGRADA'
      sig1Title.font = { name: 'Arial', size: 7, bold: true }
      sig1Title.alignment = { ...centerAlign, wrapText: true }
      sig1Title.border = { bottom: thin }

      // Block 2: PRESTADOR
      ws.mergeCells(`E${row}:G${row}`)
      const sig2Title = ws.getCell(`E${row}`)
      sig2Title.value = 'PRESTADOR DEL SERVICIO\nKONECT LOGÍSTICA INTEGRADA'
      sig2Title.font = { name: 'Arial', size: 7, bold: true }
      sig2Title.alignment = { ...centerAlign, wrapText: true }
      sig2Title.border = { bottom: thin }

      // Block 3: DIRECTOR GENERAL
      ws.mergeCells(`I${row}:K${row}`)
      const sig3Title = ws.getCell(`I${row}`)
      sig3Title.value = 'DIRECTOR GENERAL DE MOVILIDAD Y\nTRANSPORTE'
      sig3Title.font = { name: 'Arial', size: 7, bold: true }
      sig3Title.alignment = { ...centerAlign, wrapText: true }
      sig3Title.border = { bottom: thin }
      row++

      // Names under signatures
      ws.mergeCells(`A${row}:C${row}`)
      const sig1Name = ws.getCell(`A${row}`)
      sig1Name.value = 'EDGAR EMMANUEL MARTÍNEZ NUÑEZ'
      sig1Name.font = { name: 'Arial', size: 7 }
      sig1Name.alignment = centerAlign

      ws.mergeCells(`E${row}:G${row}`)
      const sig2Name = ws.getCell(`E${row}`)
      sig2Name.value = 'KARLA JEOVANA RAMIREZ ALEJANDRO'
      sig2Name.font = { name: 'Arial', size: 7 }
      sig2Name.alignment = centerAlign

      ws.mergeCells(`I${row}:K${row}`)
      const sig3Name = ws.getCell(`I${row}`)
      sig3Name.value = 'ING. JEAN CARLOS RUIZ GARCIA\nING. MONICA JANETH SÁNCHEZ'
      sig3Name.font = { name: 'Arial', size: 7 }
      sig3Name.alignment = { ...centerAlign, wrapText: true }
      row += 2

      // ============ CONTRATO FOOTER ============
      const blueTop = { top: { style: 'medium', color: { argb: 'FF1F3864' } } }
      for (let c = 1; c <= 11; c++) ws.getCell(row, c).border = blueTop

      ws.getCell(`A${row}`).value = 'CONTRATO:'
      ws.getCell(`A${row}`).font = { name: 'Arial', size: 8, bold: true }
      ws.getCell(`B${row}`).value = 'SDU-041-2025'
      ws.getCell(`B${row}`).font = { name: 'Arial', size: 8 }

      ws.getCell(`E${row}`).value = 'REPORTE No.'
      ws.getCell(`E${row}`).font = { name: 'Arial', size: 8, bold: true }
      const reportMonth = moment(filtros.fecha_fin, 'YYYY-MM-DD').format('MM/YYYY')
      ws.getCell(`F${row}`).value = reportMonth
      ws.getCell(`F${row}`).font = { name: 'Arial', size: 8 }

      // Hoja pagination
      ws.getCell(`J${row}`).value = `Hoja ${sheetNum} de ${totalSheets}`
      ws.getCell(`J${row}`).font = { name: 'Arial', size: 8, bold: true }
      ws.getCell(`J${row}`).alignment = { horizontal: 'right', vertical: 'middle' }

      }) // end periods.forEach

      this._appendDetalleViajesSheet(workbook, filtros, clienteNombre)

      // ============ DOWNLOAD ============
      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const fileName = `ReporteRegioRutaExtendido_${filtros.fecha_inicio}_a_${filtros.fecha_fin}.xlsx`
      saveAs(blob, fileName)
    },

    async _buildPDF(rutas, totales, filtros, clienteNombre) {
      const { jsPDF } = await import(/* webpackChunkName: "jspdf" */ 'jspdf')
      const autoTableModule = await import(/* webpackChunkName: "jspdf-autotable" */ 'jspdf-autotable')
      const autoTable = autoTableModule.default || autoTableModule.autoTable || autoTableModule

      const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'letter' })
      const pageW = doc.internal.pageSize.getWidth()
      const fmtDate = (d) => moment(d, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY')
      const fmtMoney = (n) => `$${(n || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
      const fmtNum = (n) => (n || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      // --- Logos ---
      const toBase64 = (url) => fetch(url).then(r => r.blob()).then(b => new Promise((ok) => {
        const reader = new FileReader()
        reader.onloadend = () => ok(reader.result)
        reader.readAsDataURL(b)
      }))

      const [logoGobB64, logoSecB64] = await Promise.all([
        toBase64('/img/logogobmty.png'),
        toBase64('/img/logoregioruta.png'),
      ])

      // --- Group data by period ---
      const periods = this._groupDataByPeriod(rutas, this.tipoReporte)
      const totalPages = periods.length
      const reportTitle = this._getReportTitle()

      periods.forEach((period, idx) => {
      const periodRutas = period.rutas
      const periodTotales = period.totales
      const pageNum = idx + 1
      if (idx > 0) doc.addPage()

      doc.addImage(logoGobB64, 'PNG', 10, 8, 38, 14)
      doc.addImage(logoSecB64, 'PNG', pageW - 52, 8, 42, 13)

      // --- Title ---
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(12)
      doc.text('SERVICIO DE TRANSPORTACIÓN REGIO RUTA', pageW / 2, 14, { align: 'center' })
      doc.setFontSize(10)
      doc.text(reportTitle, pageW / 2, 20, { align: 'center' })

      // --- Build table data ---
      const bodyRows = []
      const subtotalRowIndices = []

      periodRutas.forEach((ruta, ri) => {
        let rutaRowNum = 1
        ;(ruta.ramales || []).forEach((ramal) => {
          const letraRamal = (ramal.nombre_ramal || '').charAt(0).toUpperCase() || String(ri + 1)
          ;(ramal.recorridos || []).forEach((rec) => {
            const m = moment(rec.fecha, ['YYYY-MM-DD', 'DD/MM/YYYY'])
            const ecoDigits = (rec.no_economico || '').match(/^\d+/)?.[0] || ''
            const noReporte = `${m.format('YYMM')}-${ecoDigits}`
            const isDaily = this.tipoReporte === 'diario'
            bodyRows.push([
              rutaRowNum,
              `Servicio de transportación integral en la Ruta ${letraRamal}`,
              'Km',
              fmtMoney(ramal.costo_km),
              rec.no_economico || '',
              noReporte,
              isDaily ? fmtDate(rec.fecha) : period.fechaInicio,
              isDaily ? fmtDate(rec.fecha) : period.fechaFin,
              rec.corridas || 1,
              fmtNum(rec.km),
              fmtMoney(rec.importe),
            ])
            rutaRowNum++
          })
        })
        // Subtotal row
        const letraRuta = ((ruta.ramales || [])[0]?.nombre_ramal || '').charAt(0).toUpperCase() || String(ri + 1)
        subtotalRowIndices.push(bodyRows.length)
        bodyRows.push([
          { content: `TOTAL DE CORRIDAS RUTA ${letraRuta}, KM Y SUBTOTAL`, colSpan: 8 },
          ruta.total_corridas || 0,
          fmtNum(ruta.subtotal_km),
          fmtMoney(ruta.subtotal_importe),
        ])
      })

      // --- Auto Table ---
      const darkBlue = [31, 56, 100]
      const medBlue = [46, 85, 153]

      autoTable(doc, {
        startY: 26,
        margin: { left: 10, right: 10 },
        theme: 'grid',
        styles: { font: 'helvetica', fontSize: 6, cellPadding: 1.2, lineColor: [0, 0, 0], lineWidth: 0.1 },
        headStyles: { fillColor: darkBlue, textColor: 255, fontStyle: 'bold', halign: 'center', valign: 'middle', fontSize: 6 },
        head: [
          [
            { content: 'No.', rowSpan: 2 },
            { content: 'CONCEPTO', rowSpan: 2 },
            { content: 'UNIDAD', rowSpan: 2 },
            { content: 'PRECIO\nUNITARIO', rowSpan: 2 },
            { content: 'No. ECO', rowSpan: 2 },
            { content: 'No. REPORTE', rowSpan: 2 },
            { content: 'PERIODO', colSpan: 2 },
            { content: 'RECORRIDO', colSpan: 2 },
            { content: 'IMPORTE', rowSpan: 2 },
          ],
          ['', '', '', '', '', '', 'INICIO', 'FINAL', 'CORRIDAS', 'Km', ''],
        ],
        body: bodyRows,
        columnStyles: {
          0: { halign: 'center', cellWidth: 8 },
          1: { halign: 'left', cellWidth: 62 },
          2: { halign: 'center', cellWidth: 12 },
          3: { halign: 'right', cellWidth: 18 },
          4: { halign: 'center', cellWidth: 14 },
          5: { halign: 'center', cellWidth: 18 },
          6: { halign: 'center', cellWidth: 20 },
          7: { halign: 'center', cellWidth: 20 },
          8: { halign: 'center', cellWidth: 14 },
          9: { halign: 'right', cellWidth: 16 },
          10: { halign: 'right', cellWidth: 22 },
        },
        didParseCell: function (data) {
          if (data.section === 'body' && subtotalRowIndices.includes(data.row.index)) {
            data.cell.styles.fillColor = medBlue
            data.cell.styles.textColor = 255
            data.cell.styles.fontStyle = 'bold'
          }
        },
      })

      // --- Footer area ---
      let y = (doc.lastAutoTable?.finalY || doc.previousAutoTable?.finalY || 180) + 6
      const pageH = doc.internal.pageSize.getHeight()

      // Check if we need a new page for footer
      if (y + 50 > pageH) {
        doc.addPage()
        y = 15
      }

      // SUB-TOTAL
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(9)
      doc.text('SUB-TOTAL', pageW - 55, y, { align: 'right' })
      doc.text(fmtMoney(periodTotales.importe || 0), pageW - 12, y, { align: 'right' })
      y += 5

      // ACUMULADO
      doc.setDrawColor(0)
      doc.rect(pageW - 65, y, 55, 10)
      doc.setFontSize(7)
      doc.text('ACUMULADO\nVALOR DE EST.', pageW - 55, y + 4, { align: 'center', maxWidth: 25 })
      doc.setFontSize(9)
      doc.text(fmtMoney(periodTotales.importe || 0), pageW - 12, y + 6, { align: 'right' })
      y += 18

      // --- Signature blocks ---
      doc.setFontSize(6)
      doc.setFont('helvetica', 'bold')
      const sigY = y
      const sig1X = 40
      const sig2X = pageW / 2
      const sig3X = pageW - 40

      doc.setDrawColor(0)
      doc.line(sig1X - 28, sigY, sig1X + 28, sigY)
      doc.text('MONITOREO DEL SERVICIO\nKONECT LOGÍSTICA INTEGRADA', sig1X, sigY + 3, { align: 'center' })
      doc.setFont('helvetica', 'normal')
      doc.text('EDGAR EMMANUEL MARTÍNEZ NUÑEZ', sig1X, sigY + 8, { align: 'center' })

      doc.setFont('helvetica', 'bold')
      doc.line(sig2X - 28, sigY, sig2X + 28, sigY)
      doc.text('PRESTADOR DEL SERVICIO\nKONECT LOGÍSTICA INTEGRADA', sig2X, sigY + 3, { align: 'center' })
      doc.setFont('helvetica', 'normal')
      doc.text('KARLA JEOVANA RAMIREZ ALEJANDRO', sig2X, sigY + 8, { align: 'center' })

      doc.setFont('helvetica', 'bold')
      doc.line(sig3X - 28, sigY, sig3X + 28, sigY)
      doc.text('DIRECTOR GENERAL DE MOVILIDAD Y\nTRANSPORTE', sig3X, sigY + 3, { align: 'center' })
      doc.setFont('helvetica', 'normal')
      doc.text('ING. JEAN CARLOS RUIZ GARCIA\nING. MONICA JANETH SÁNCHEZ', sig3X, sigY + 8, { align: 'center' })
      y = sigY + 16

      // --- CONTRATO Footer ---
      doc.setDrawColor(31, 56, 100)
      doc.setLineWidth(0.5)
      doc.line(10, y, pageW - 10, y)
      y += 4
      doc.setFontSize(7)
      doc.setFont('helvetica', 'bold')
      doc.text('CONTRATO:', 12, y)
      doc.setFont('helvetica', 'normal')
      doc.text('SDU-041-2025', 32, y)

      doc.setFont('helvetica', 'bold')
      doc.text('REPORTE No.', pageW / 2 - 10, y)
      doc.setFont('helvetica', 'normal')
      const reportMonth = moment(filtros.fecha_fin, 'YYYY-MM-DD').format('MM/YYYY')
      doc.text(reportMonth, pageW / 2 + 15, y)

      // Hoja pagination
      doc.setFont('helvetica', 'bold')
      doc.text(`Hoja ${pageNum} de ${totalPages}`, pageW - 12, y, { align: 'right' })

      }) // end periods.forEach

      // --- Save ---
      const fileName = `ReporteRegioRutaExtendido_${filtros.fecha_inicio}_a_${filtros.fecha_fin}.pdf`
      doc.save(fileName)
    },

    exportarCSV() {
      try {
        this.loadingReports = true
        const dataset = this.itemsFiltered
        const cols = this.exportColumns
        const headers = cols.map((h) => h.text)
        const keys = cols.map((h) => h.value)

        const rows = (dataset || []).map((row) =>
          keys.map((k) => this.getExportCellValue(row, k))
        )

        const csv = [this.toCsvRow(headers), ...rows.map(this.toCsvRow)].join('\n')
        const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' })
        const nombre = `repRegRtExt_${this.filtros.fecha_inicio}_a_${this.filtros.fecha_fin}.csv`
        downloadjs(blob, nombre, 'text/csv;charset=utf-8')
      } catch (e) {
        this.error = true
        this.codeError = e.message || 'Error al exportar CSV'
      } finally {
        this.loadingReports = false
      }
    }
  }
}
</script>

<style scoped>
.v-application--is-ltr .v-btn-toggle > .v-btn.v-btn:not(:first-child) {
  border-left-width: 1;
}
#mapa-detalle {
  background: #f5f5f5;
}
.reference-points-table th {
  font-size: 0.75rem;
  white-space: nowrap;
}
.reference-points-table td {
  font-size: 0.8125rem;
}
.map-detail-info {
  background: #f7f7f9;
  border-radius: 10px;
  padding: 6px 12px;
}
.ref-points-list .v-list-item {
  min-height: 52px;
}
.ref-point-meta {
  column-gap: 12px;
  row-gap: 2px;
  margin-top: 2px;
}
.map-detail-body {
  align-items: stretch;
}
.map-detail-map {
  min-width: 0;
}
.map-detail-side {
  width: 100%;
  max-height: 45vh;
  overflow-y: auto;
}
@media (min-width: 960px) {
  .map-detail-side {
    flex: 0 0 380px;
    width: 380px;
    max-height: 65vh;
    border-left: 1px solid rgba(0, 0, 0, 0.08);
  }
}
.map-detail-wrapper {
  width: 100%;
}
.gps-sample-table {
  max-height: 200px;
  overflow-y: auto;
}
.gps-sample-table >>> th {
  font-size: 0.75rem !important;
  font-weight: 600;
  white-space: nowrap;
}
.gps-sample-table >>> td {
  font-size: 0.8125rem !important;
  height: 36px !important;
  font-variant-numeric: tabular-nums;
}
.gps-sample-row {
  cursor: pointer;
}
.gps-sample-row:hover {
  background: rgba(0, 0, 0, 0.04);
}
.gps-sample-row:focus-visible {
  outline: 2px solid #1976d2;
  outline-offset: -2px;
  background: rgba(25, 118, 210, 0.08);
}
.gps-num {
  font-variant-numeric: tabular-nums;
}
.gps-odometer-cell {
  font-size: 0.8125rem;
  line-height: 1.2;
}
.gps-table-bottom {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  background: #fafafa;
}
.gps-table-bottom .gps-sample-table--wide {
  max-height: 26vh;
  overflow-y: auto;
}
.d-sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
</style>
